import React from 'react';

const GuardianSVG = () =>
  <svg height="70px" width="71px" version="1.1" viewBox="0 0 71 70">
    <g fill="none" stroke="none" strokeWidth="1">
      <g transform="translate(-249.000000, -367.000000)">
        <g transform="translate(96.000000, 367.000000)">
          <g transform="translate(153.000000, 0.000000)">
            <path
              d="M18.6794258,70 L51.3684211,70 C61.6847177,70 70.0478469,61.6425833 70.0478469,51.3333333 L70.0478469,18.6666667 C70.0478469,8.35741667 61.6847177,0 51.3684211,0 L18.6794258,0 C8.36312919,0 0,8.35741667 0,18.6666667 L0,51.3333333 C0,61.6425833 8.36312919,70 18.6794258,70"
              fill="#EC5424"
            />
            <path
              d="M49.3806967,15.3375833 L35.0255579,15.3375833 L20.6692517,15.3372917 L16.2334718,29.0535 C13.5345866,37.4759583 16.6820699,46.3411667 23.4098737,51.2499167 L35.023223,59.7280833 L46.6403665,51.2484583 C53.7321273,46.0725417 56.3878163,37.044 53.8334048,29.0957917 C53.8228976,29.05875 49.3806967,15.3375833 49.3806967,15.3375833 Z"
              fill="#222228"
            />
            <polygon
              fill="#FFFFFF"
              points="35.0237775 15.3372333 39.4770694 29.0336083 53.8879545 29.0336083 42.229366 37.4983583 46.6826579 51.1947333 35.0237775 42.7299833 23.3648971 51.1947333 27.818189 37.4983583 16.1596005 29.0336083 30.5704856 29.0336083"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>;

export default GuardianSVG;



// WEBPACK FOOTER //
// ./src/svg/GuardianSVG.js